import React from "react";
import "./ProductsByBrand.css";
import { Link } from "react-router-dom";
import { createSlug } from "../../../utils/createSlug";

function ProductsByBrand({ brands }) {
  return (
    <div className="productbybrand-container container">
      <div className="brandtitle-section">
        <h1>
          FILTER BY
          <br />
          <span>BRANDS</span>
        </h1>
        <div className="plusicon-image">
          <Link to="/productsByCategory">
            <img src="/images/plusicon.png" alt="plus icon" width={120} />
          </Link>
        </div>
      </div>
      <div className="brands-list">
        {brands.map((brand, index) => (
          <div key={brand.id} className="brand-block">
            <h2 className="brand-title">{brand.name}</h2>
            <div className="products-grid">
              {brand.products.map((product, i) => (
                <div key={i} className="product-name">
                  <Link to={`/product/${createSlug(product.name)}`}>
                    {product.name}
                  </Link>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ProductsByBrand;
